const statusOrderChoice = [
    { id: 1, name: 'Enviado' },
    { id: 2, name: 'Entregue' },
    { id: 3, name: 'Avaliado' },
    { id: 4, name: 'Devolvido' },
    { id: 5, name: 'Perdido' },
]

export default statusOrderChoice;
